import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Home from '../views/pedido/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: {
      title: 'Syclus Coletor - Login'
    }
  },
  // Pedidos
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'Syclus Coletor - Home'
    }
  },
  {
    path: '/pedidos/:id',
    name: 'Pedido',
    props: true,
    component: () => import('../views/pedido/Pedido.vue'),
    meta: {
      title: 'Syclus Coletor - Pedido'
    }
  },
  {
    path: '/pedidos/:id/coletas/:idProduto',
    name: 'PedidoColetas',
    props: true,
    component: () => import('../views/pedido/PedidoColetas.vue'),
    meta: {
      title: 'Syclus Coletor - Pedido Coletas'
    }
  },
  // Produções
  {
    path: '/producoes',
    name: 'Producoes',
    component: () => import('../views/producao/Producoes.vue'),
    meta: {
      title: 'Syclus Coletor - Produções'
    }
  },
  {
    path: '/producoes/:id',
    name: 'Producao',
    props: true,
    component: () => import('../views/producao/Producao.vue'),
    meta: {
      title: 'Syclus Coletor - Produção'
    }
  },
  {
    path: '/producoes/:id/coletas/:idProduto',
    name: 'ProducaoColetas',
    props: true,
    component: () => import('../views/producao/ProducaoColetas.vue'),
    meta: {
      title: 'Syclus Coletor - Produção Coletas'
    }
  },
  // Requisições
  {
    path: '/requisicoes',
    name: 'Requisicoes',
    component: () => import('../views/requisicao/Requisicoes.vue'),
    meta: {
      title: 'Syclus Coletor - Requisições'
    }
  },
  {
    path: '/requisicoes/:id',
    name: 'Requisicao',
    props: true,
    component: () => import('../views/requisicao/Requisicao.vue'),
    meta: {
      title: 'Syclus Coletor - Requisição'
    }
  },
  // Configurações
  {
    path: '/configuracoes',
    name: 'Configuracoes',
    component: () => import('../views/Configuracoes.vue'),
    meta: {
      title: 'Syclus Coletor - Configurações'
    }
  },
  // About
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    meta: {
      title: 'Syclus Coletor - Sobre'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to acces a restricted page
  const publicPages = ['/login']
  const authRequired = !publicPages.includes(to.path)
  const loggedIn = store.getters.isLoggedIn;

  if (authRequired && !loggedIn) {
    return next('/login')
  } else if (to.path == '/login' && loggedIn) {
    return next('/')
  }

  document.title = to.meta.title
  next()
})

export default router
